import styled from 'styled-components';

export const LogoHolder = styled.div`
  position: absolute;
  top: 3rem;
  left: 3rem;
  bottom: 7rem;
  right: ${({ $isMobile }) => $isMobile ? '3rem' : 'unset'};
  display: flex;
  flex-direction: ${({ $isMobile }) => $isMobile ? 'row' : 'column'};
  justify-content: center;
  align-items: center;
`

export const StyledMintComponent = styled.div `
  width: 100%;
  padding: 0px 20px;
  background: ${({theme}) => theme.background};
  left: 0;
  right: ${({ theme }) => theme.frameOffset};
  top: ${({ theme }) => theme.navHeight};  
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: 0;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px;
  background: ${({theme}) => theme.mintDarkblue};

  @media (max-width: ${({ theme }) => theme.mobile}) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 12px;
    padding-top: 12px;
  }
`
  
export const Delimiter = styled.div`
  width: 100%;
  height: 10px;
  background: white;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    height: 4px;
  }
`

export const Trailer = styled.video`
  width: 100%;
`

export const TrailerText = styled.div`
  position: absolute;
  top: 50%;
  right: 3rem;
  width: calc(100% - 8rem - 22rem); 
  transform: translateY(-50%);
  font-family: "BebasNeue";
  font-size: 4.5rem;
  font-weight: 800;
  text-shadow: 2px 0 #121FAA, -2px 0 #121FAA, 0 2px #121FAA, 0 -2px #121FAA,
             1px 1px #121FAA, -1px -1px #121FAA, 1px -1px #121FAA, -1px 1px #121FAA;

  @media (max-width: 1280px) {
      font-size: 4.2rem;
  }

  @media (max-width: 1080px) {
    font-size: 3.5rem;
  }

  @media (max-width: 960px) {
    font-size: 3.125rem;    
  }

  @media (max-width: 840px) {
    font-size: 2.75rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    font-size: 2.5rem;
  }
`;

export const TrailerControls = styled.div`
  position: absolute;
  bottom: 3rem;
  right: 3rem;
`

export const TrailerContainer = styled.div`
  position: relative;
  width: 100%;
`
